// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 2H1V18H23V2ZM15.9137 10.6356L11.9998 14.3848L8.08594 10.6356L9.46942 9.19136L10.9998 10.6573V6H12.9998V10.6573L14.5302 9.19136L15.9137 10.6356Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 20H3V22H21V20Z"}}]};

const Download2FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'download-2-filled',
    ref,
    icon: element,
  },
));

Download2FilledIcon.displayName = 'Download2FilledIcon';

export default Download2FilledIcon;
